import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from '../../../ui/api/action.component';
@Component({
    selector: 'wishlist-toggle',
    templateUrl: 'wishlist-toggle.html',
    standalone: true,
    imports: [NgClass, ActionComponent, SizeClassDirective, TranslationModule]
})
export class WishlistToggleComponent extends WishlistToggleComponentDef {
    /**
     * Parent id
     */
    @Input({
        required: true
    })
    parentId!: number;

    @Input()
    gridSize?: number;
    /**
     * Checks if item is in wishlist alread
     */
    override get inWishlist(): boolean {
        if (!!this.item) {
            return true;
        }
        const items = this.productId && this.wishlist.getItemsByProduct(this.productId);
        return (items && items.length > 0) || this.parentInWishlist;
    }

    get parentInWishlist(): boolean {
        const parents = this.parentId && this.wishlist.getItemsByProduct(this.parentId);
        return parents ? parents.length > 0 : false;
    }
}
